import {Col} from 'react-bootstrap';

export default function CustomTitle({title}){
    return(
        <Col md={12} className='container-body-2 customTitle'>
            <h3 className="parrafo">{title}</h3> 
        </Col>    
    ) 
}